import React, { useState, useEffect } from 'react';

// Import CSS & assets
import ico_dots from '../../../../assets/ico/ico_dots.svg';
import ico_close from '../../../../assets/ico/ico_close_white.svg';
import ico_ignore from '../../../../assets/ico/ico_ignore_white.svg';
import ico_warning_red from '../../../../assets/ico/ico_warning_red.svg';
import ico_warning_blue from '../../../../assets/ico/ico_warning_blue.svg';
import ico_map_layers_highlight from '../../../../assets/ico/ico_map_layers_highlight.svg';
import ico_ia_stars from '../../../../assets/ico/ico_ia_3_stars.svg';
import ico_arrow from '../../../../assets/ico/ico_arrow_up.svg';


// Import components
import RuleVariable from './RuleVariable';
import RuleResult from './RuleResult';

// Import external functions
import * as nodeHelpers from '../../ruleEditor_elements/helpers/NodeHelpers';


const Rule = ({ rule_id, name, data, ruleCatalog_Open, rule_Update, rule_Update_Source, rule_Update_Comment, rule_Update_Title, rule_Update_Ignorance, rule_Delete, condition_Delete, perimeter_Delete, capacity, highlightedRule, setHighlightedRule, rule, ruleset, mapDrawMode, setMapDrawMode, hiddenRule, setHiddenRule }) => {

    // Ignorance
    const switchIgnored = () => {
        var newIgnorance = true;
        if (rule?.isIgnored === true) {
            newIgnorance = false;
        }
        rule_Update_Ignorance(rule_id, newIgnorance);
    }

    // Document actions
    const [isActions, setIsActions] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isSourceDocOpen, setIsSourceDocOpen] = useState(-1);
    const [isSourcePageOpen, setIsSourcePageOpen] = useState(-1);

    const handleClickDelete = () => {
        setIsActions(false);
        setIsDelete(true);
    }

    // Params visibility
    const [isParamsVisible, setIsParamsVisible] = useState(false);
    const isParamCurrent = () => {
        console.log("CHECK CURRENT PARAMS");
        if (data?.params?.condition?.value === true && data?.params?.condition?.data !== null) {
            return true
        }
        else if (data?.params?.perimeter?.value === true && data?.params?.perimeter?.data !== null) {
            return true
        }
        else {
            return false
        }
    }
    const paramsOpen = () => {
        setIsParamsVisible(true);
    }
    const paramsClose = () => {
        setIsParamsVisible(false);
    }
    useEffect(() => {
        if (isParamCurrent()) {
            paramsOpen();
        }
        try {
            document.getElementById(rule_id + "_comment_input_string_long").value = rule?.comment || "";
        } catch (error) {
        }
    }, [])

    // Variable
    const updateVariable = (type, variableLabel, value, valueObject) => {
        console.log("UPDATING " + variableLabel + " to :", value);
        console.log("type", type);
        console.log("data", data);
        console.log("rule", rule);
        console.log("valueObject", valueObject);
        // document.getElementById(variableId).style.width = (value.length * 7.4).toString() + "px";
        // Get current data
        var newData = { ...data };
        var currentData = null;
        if (type === "condition" || type === "perimeter") {
            currentData = { ...data.params[type].data.data };
        }
        else if (type === "description") {
            currentData = { ...data };
        }
        console.log("currentData", currentData);

        // Search matching variable in description part
        var searchString = "";
        for (var i = 0; i < currentData.variables_description.length; i++) {
            if (currentData.variables_description[i].label === variableLabel) {
                // Update variable value
                currentData.variables_description[i].value = value;
                if (valueObject) {
                    currentData.variables_description[i].value = valueObject;
                }
                // Get searchString
                searchString = currentData.variables_description[i].searchString;
                break;
            }
        }
        // Search matching variable in input part
        for (var i = 0; i < currentData.variables_input.length; i++) {
            if (currentData.variables_input[i].label === variableLabel) {
                // Update variable value
                currentData.variables_input[i].value = value;
                if (valueObject) {
                    currentData.variables_input[i].value = valueObject;
                }
                // Get searchString
                searchString = currentData.variables_description[i].searchString;
            }
        }
        // Get variable inside main node value
        var mainNodeIndex = -1;
        var mainNodeValue = "";
        for (var i = 0; i < currentData.composition.nodes.length; i++) {
            if (currentData.composition.nodes[i].type.includes("Node_Rule_") || currentData.composition.nodes[i].type.includes("Node_Condition") || currentData.composition.nodes[i].type.includes("Node_Perimeter")) {
                mainNodeIndex = i;
                mainNodeValue = currentData.composition.nodes[i].data.source[0].value;
                break;
            }
        }
        if (mainNodeIndex >= 0) {
            // Update main node value with new variable value
            var stringValue = value.toString();
            var newMainNodeValue = replaceVariable(mainNodeValue, searchString, stringValue, 0);
            console.log("newMainNodeValue", newMainNodeValue);
            currentData.composition.nodes[mainNodeIndex].data.source[0].value = newMainNodeValue;
        }

        // Interpretation
        var currentData_interpreted = nodeHelpers.nodeInterpretor(currentData.composition.nodes[0].data.source, capacity, newData?.params?.perimeter);
        var rule_interpreted = null;


        // Replace current data if type !== rule
        if (type === "condition" || type === "perimeter") {
            newData.params[type].data.data = currentData;
            newData.params[type].data.interpreted = currentData_interpreted;
            // Rule interpretation
            // if (type === "condition" && currentData_interpreted === false) {
            if ((type === "condition" && currentData_interpreted === false) || (type === "perimeter" && newData?.params?.condition?.data?.interpreted === false)) {
                rule_interpreted = [];
            }
            // else if (type === "condition" && currentData_interpreted === true) {
            else {
                rule_interpreted = nodeHelpers.nodeInterpretor(newData.composition.nodes[0].data.source, capacity, newData?.params?.perimeter);
            }
        }
        else {
            rule_interpreted = currentData_interpreted;
            console.log("rule_interpreted", rule_interpreted);
            // Stringify three object
            if (Array.isArray(rule_interpreted)) {
                rule_interpreted.forEach(object => {
                    object = object.toJSON;
                });
            }
            else {
                rule_interpreted = rule_interpreted.toJSON;
            }
        }
        console.log("newData", newData);
        console.log("rule_interpreted", rule_interpreted);
        // Update all rule
        rule_Update(rule_id, newData, rule_interpreted);
    }

    function replaceVariable(mainNodeValue, searchString, value, start) {
        console.log("mainNodeValue", mainNodeValue);
        console.log("searchString", searchString);
        console.log("value", value);
        console.log("start", start);

        if (searchString === "" || searchString === undefined || searchString === null) {
            console.error("ERROR: SearchString is undefined");
            return mainNodeValue
        }

        var newString = mainNodeValue.substring(start, mainNodeValue.length);
        // Get startIndex
        var startIndex = newString.indexOf(searchString);
        if (startIndex >= 0) {
            // Get endIndex
            var newShortString = newString.substring(startIndex + searchString.length, newString.length);
            var endIndex = newShortString.indexOf("]");
            var count = 0;
            for (var i = 0; i < newShortString.length; i++) {
                if (newShortString[i] === "[") {
                    count++;
                }
                if (newShortString[i] === "]") {
                    count--;
                }
                if (count < 0) {
                    endIndex = i;
                    break;
                }
            }
            // Get left & right parts
            var leftPart = mainNodeValue.substring(0, start + startIndex) + searchString;
            var rightPart = newShortString.substring(endIndex, newShortString.length);
            // Update mainNodeValue
            mainNodeValue = leftPart + value + rightPart;
            // recursive
            mainNodeValue = replaceVariable(mainNodeValue, searchString, value, start + startIndex + searchString.length)
        }
        return mainNodeValue;
    }

    // const updateVariableParams = (type, variableLabel, value) => {
    //     console.log("UPDATING VARIABLE for '" + variableLabel + "' to :", value);
    //     // Get current data
    //     var newData = { ...data };
    //     // Search matching variable
    //     for (var i = 0; i < newData.params[type].data.data.variables_description.length; i++) {
    //         if (newData.params[type].data.data.variables_description[i].label === variableLabel) {
    //             // Update variable value
    //             newData.params[type].data.data.variables_description[i].value = value;
    //         }
    //     }
    //     for (var i = 0; i < newData.params[type].data.data.variables_input.length; i++) {
    //         if (newData.params[type].data.data.variables_input[i].label === variableLabel) {
    //             // Update variable value
    //             newData.params[type].data.data.variables_input[i].value = value;
    //         }
    //     }
    //     console.log("newData", newData);
    //     // Update all rule
    //     rule_Update(id, newData);
    // }

    // Title
    const updateTitle = (title) => {
        if (title !== name) {
            rule_Update_Title(rule_id, title);
        }
    }

    // SOURCE
    const handleDocSelectionClick = (source_i) => {
        // setIsSourcePageOpen(false);
        setIsSourcePageOpen(-1);
        // if (isSourceDocOpen) {
        // setIsSourceDocOpen(false);
        // }
        // else {
        // setIsSourceDocOpen(true);
        // }
        setIsSourceDocOpen(source_i);
    }
    const handleDocClick = (docData, source_i) => {
        // Check if already selected doc
        if (docData?.url === rule?.sources[source_i]?.doc?.url) {
            updateSource(null, null, source_i);
            // setIsSourceDocOpen(false);
            setIsSourceDocOpen(-1);
        }
        else {
            updateSource(docData, "1", source_i);
            // setIsSourceDocOpen(false);
            setIsSourceDocOpen(-1);
        }
    }
    const updateSource = (source_doc, source_page, source_i) => {
        // var newSource = { doc: source_doc, page: source_page };
        var newSources = rule?.sources ? [...rule.sources] : [{ doc: null, page: null }, { doc: null, page: null }, { doc: null, page: null }];
        newSources[source_i] = { doc: source_doc, page: source_page };
        // rule_Update_Source(rule_id, newSource);
        rule_Update_Source(rule_id, newSources);
    }
    const handlePageSelectionClick = (source_i) => {
        // setIsSourceDocOpen(false);
        setIsSourceDocOpen(-1);
        // if (isSourcePageOpen) {
        // setIsSourcePageOpen(false);
        // }
        // else {
        // setIsSourcePageOpen(true);
        // }
        setIsSourcePageOpen(source_i);
    }
    const handlePagChange = (pageNum, source_i) => {
        console.log("Change page", pageNum, source_i);
        // Check if page is valid and not already same value
        // if (pageNum > 0 && pageNum !== rule?.source?.page) {
        if (pageNum > 0 && pageNum !== rule?.sources[source_i]?.page) {
            updateSource(rule?.sources[source_i]?.doc, pageNum, source_i);
        }
        // setIsSourcePageOpen(false);
        setIsSourcePageOpen(-1);
    }

    // COMMENT
    const getRowNb = (value) => {
        var nb_rows = 1;
        if (value !== "") {
            var nb_lines = value.split("\n").length;
            nb_rows = Math.max(1, nb_lines);
        }
        return nb_rows.toString();
    }
    const [nbRowsComment, setNbRowsComment] = useState(getRowNb(rule?.comment || ""));
    const handleCommentChange = (newComment) => {
        console.log("Change comment", newComment);
        setNbRowsComment(getRowNb(newComment));
    }
    const updateComment = (newComment) => {
        rule_Update_Comment(rule_id, newComment);
    }


    return (
        <div id={"rule_element_" + rule_id} className={`app__ruleset_rule ${ruleset?.isFromAI ? "app__ruleset_rule_AI" : ""}`}>
            <div className="app__ruleset_title_header">
                {/* <div className="app__ruleset_rule_label">{rule?.numerotation ? rule.numerotation + " " : ""}{name}</div> */}
                <div className="app__ruleset_rule_label" contentEditable={true} onBlur={(e) => { updateTitle(e.target.innerText) }}>{name}</div>
                <div style={{ display: "flex", gap: "10px", position: "relative", top: "-11px" }}>
                    {(highlightedRule !== null && data.composition.nodes[0].data?.isMapVisible === true && !(rule?.isIgnored === true)) &&
                        <div className="app__sectiondata_widget_layer">
                            <img src={ico_map_layers_highlight} alt="ico_map_layers" />
                            <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id={"sectiondata_switch_highlightedRule_" + rule_id} checked={highlightedRule === rule_id ? true : false} onChange={() => { highlightedRule === rule_id ? setHighlightedRule("all") : setHighlightedRule(rule_id) }} /><label className="app__map_layer_checkbox_label" htmlFor={"sectiondata_switch_highlightedRule_" + rule_id}>Toggle</label></div>
                        </div>
                    }
                    {!(data?.composition?.nodes[0]?.type === "Node_Rule_Simple_Text" || data?.composition?.nodes[0]?.type === "Node_Rule_Destinations") &&
                        <div className={`app__ruleset_title_button_container ${rule?.isIgnored === true ? "app__ruleset_title_button_container_visible" : ""}`} title="Ignorer cette règle" onClick={() => { switchIgnored() }}>
                            <img src={ico_ignore} alt="ignore" style={{ height: '14px' }} />
                        </div>
                    }
                    <div className="app__ruleset_title_button_container" title="Supprimer cette règle" onClick={() => { setIsDelete(true) }}>
                        <img src={ico_close} alt="close" />
                    </div>
                </div>
                {/* {ruleset?.isFromAI &&
                    <div className="app__ruleset_info_from_IA" style={{ top: '-14px', left: '0px' }}>
                        <img src={ico_ia_stars} />
                        <div className="app__ruleset_info_from_IA_text">Généré par IA</div>
                    </div>
                } */}
                {data?.composition?.nodes[0]?.type === "Node_Rule_Simple_Text" &&
                    <div className="app__ruleset_rule_warning_blue"><img src={ico_warning_blue} alt="" />règle à but informatif, pas prise en compte dans le calcul capacitaire</div>
                }
            </div>
            {/* DESCRIPTION */}
            <div style={{ height: "8px" }}></div>
            <div className="app__ruleset_rule_description_container">
                {(data?.description_splitted && data.description_splitted.length > 0) ?
                    <div className="app__ruleset_rule_description_subcontainer">
                        <div className="app__ruleset_rule_description">
                            {data.description_splitted.map((description_part, index) => {
                                var variables_match_index = -1;
                                for (var i = 0; i < data.variables_description.length; i++) {
                                    if (data.variables_description[i].label === description_part) {
                                        variables_match_index = i;
                                        break;
                                    }
                                }
                                if (variables_match_index === -1) {
                                    return (
                                        description_part
                                    )
                                }
                                else {
                                    // if (data.variables_description[variables_match_index].type === "Node_UserInput_Number" || data.variables_description[variables_match_index].type === "Node_UserInput_Number_Range" || data.variables_description[variables_match_index].type === "Node_UserInput_Boolean" || data.variables_description[variables_match_index].type === "Node_UserInput_Bounds" || data.variables_description[variables_match_index].type === "Node_UserInput_Lands" || data.variables_description[variables_match_index].type === "Node_UserInput_PLUZone" || data.variables_description[variables_match_index].type === "Node_UserInput_Levels" || data.variables_description[variables_match_index].type === "Node_UserInput_Buildings") {
                                    if (data.variables_description[variables_match_index].type.includes("Node_UserInput_")) {
                                        return (
                                            <RuleVariable key={"var_" + rule_id + index} ruleId={rule_id} ruleLabel={rule.name} ruleType={"rule"} variable={data.variables_description[variables_match_index]} varType={"description"} updateVariable={updateVariable} capacity={capacity} mapDrawMode={mapDrawMode} setMapDrawMode={setMapDrawMode} hiddenRule={hiddenRule} setHiddenRule={setHiddenRule} ruleset={ruleset} />
                                        )
                                    }
                                    else if (data.variables_description[variables_match_index].type === "result") {
                                        return (
                                            <RuleResult rule={rule} />
                                        )
                                    }
                                    return (
                                        <span key={index} className="app__ruleset_rule_description_input">{description_part}</span>
                                    )
                                }
                            })}
                        </div>
                    </div>
                    :
                    <div className="app__ruleset_rule_description">{data.description}</div>
                }
                {data?.image &&
                    <div className="app__ruleset_rule_image"><img src={data.image} /></div>
                }
            </div>
            {/* VARIABLES */}

            {/* SOURCE */}
            {/* {capacity?.isModel &&
                <div className="app__ruleset_rule_source_container">
                    <div className="app__ruleset_rule_description_italic">Source :</div>
                    <div style={{ display: 'flex' }}>
                        <div className="app__ruleset_rule_variable_placeholder" onClick={handleDocSelectionClick}>
                            {rule?.source?.doc?.title || "Sélectionner un document"}
                        </div>
                        {rule?.source?.doc &&
                            <div style={{ position: 'relative' }}>
                                page
                                <div id={`${rule_id}_source_page_text`} className="app__ruleset_rule_variable_placeholder" onClick={handlePageSelectionClick}>
                                    {rule?.source?.page || "-"}
                                </div>
                                {isSourcePageOpen &&
                                    <div className="app__ruleset_rule_source_input_container" style={{ position: 'absolute', top: '0px', left: '29px' }}>
                                        <input id={`${rule_id}_source_page_input_number`} className="app__ruleset_rule_variable_input_element_number" autoFocus type="number" onChange={(e) => { }} onBlur={(e) => { handlePagChange(e.target.value) }} onKeyUp={(e) => { if (e.key === "Enter") { handlePagChange(e.target.value) } }} defaultValue={rule?.source?.page || 1} style={{ border: "none", width: ((rule?.source?.page || 1).toString().length * 7.4 + 20).toString() + "px" }} />
                                    </div>
                                }
                            </div>
                        }
                        {isSourceDocOpen &&
                            <div className="app__ruleset_rule_source_input_container" onMouseLeave={() => { setIsSourceDocOpen(false) }}>
                                <div style={{ padding: "1px 10px 4px", width: "fit-content" }}>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>Sélection du document</div>
                                    <div className="app__ruleset_rule_source_input_container_scroll">
                                        {Object.keys(capacity.rules?.gpu_data?.files).map((docCategory, index1) => {
                                            if (docCategory === "Règlements") {
                                                return (
                                                    <>
                                                        {Object.keys(capacity.rules.gpu_data.files[docCategory]).map((docSubcategory, index3) => {
                                                            return (
                                                                <>
                                                                    <div key={index1 + index3} style={{ marginTop: "8px" }}></div>
                                                                    <div key={index1 + index3 + "_title"} className="ruleeditor__input_title" style={{ color: "#062134" }}>{docCategory} - {docSubcategory}</div>
                                                                    <div>
                                                                        {capacity.rules.gpu_data.files[docCategory][docSubcategory].map((docItem, index2) => {
                                                                            var isSelected = false;
                                                                            if (docItem?.url && docItem?.url === rule?.source?.doc?.url) {
                                                                                isSelected = true;
                                                                            }
                                                                            return (
                                                                                <div key={index2} className={`app__ruleset_rule_source_doc_item ${isSelected ? "app__ruleset_rule_source_doc_item_selected" : ""}`} onClick={() => { handleDocClick(docItem) }}>{docItem?.title}</div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </>
                                                            )
                                                        })
                                                        }
                                                    </>
                                                )
                                            }
                                            else {
                                                return (
                                                    <>
                                                        <div key={index1} style={{ marginTop: "8px" }}></div>
                                                        <div key={index1 + "_title"} className="ruleeditor__input_title" style={{ color: "#062134" }}>{docCategory}</div>
                                                        <div>
                                                            {capacity.rules.gpu_data.files[docCategory].map((docItem, index2) => {
                                                                var isSelected = false;
                                                                if (docItem?.url && docItem?.url === rule?.source?.doc?.url) {
                                                                    isSelected = true;
                                                                }
                                                                return (
                                                                    <div key={index2} className={`app__ruleset_rule_source_doc_item ${isSelected ? "app__ruleset_rule_source_doc_item_selected" : ""}`} onClick={() => { handleDocClick(docItem) }}>{docItem?.title}</div>
                                                                )
                                                            })}
                                                        </div>
                                                    </>
                                                )
                                            }
                                        })}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
            {(capacity?.isModel === false && rule?.source?.doc?.title && rule?.source?.doc?.url) &&
                <div className="app__ruleset_rule_source_container">Source :
                    <a className="app__ruleset_rule_source_link" href={`${rule.source.doc.url}${(rule?.source?.page && rule.source.page !== "1") ? "#page=" + rule.source.page : ""}`} target="_blank">
                        {rule.source.doc.title}{(rule?.source?.page && rule.source.page !== "1") ? " (page " + rule.source.page + ")" : ""}
                    </a>
                </div>
            } */}

            {/* SOURCES */}
            {(capacity?.isModel && rule?.sources && rule.sources.length === 3) &&
                <div className="app__ruleset_rule_source_container">
                    <div className="app__ruleset_rule_description_italic">{rule.sources[1].doc?.url ? "Sources :" : "Source :"}</div>
                    {rule.sources.map((source, source_i) => {
                        if (source_i === 0 || rule.sources[source_i - 1].doc?.url) {
                            return (
                                // <div>SOURCES {source_i}</div>
                                <div style={{ display: 'flex', marginBottom: '2px' }}>
                                    <div className="app__ruleset_rule_variable_placeholder" onClick={() => { handleDocSelectionClick(source_i) }}>
                                        {rule.sources[source_i]?.doc?.title || "Sélectionner un document"}
                                    </div>
                                    {rule.sources[source_i]?.doc &&
                                        <div style={{ position: 'relative' }}>
                                            page
                                            <div id={`${rule_id}_source_page_text`} className="app__ruleset_rule_variable_placeholder" onClick={() => { handlePageSelectionClick(source_i) }}>
                                                {rule.sources[source_i]?.page || "-"}
                                            </div>
                                            {isSourcePageOpen === source_i &&
                                                <div className="app__ruleset_rule_source_input_container" style={{ position: 'absolute', top: '0px', left: '29px' }}>
                                                    <input id={`${rule_id}_source_page_input_number`} className="app__ruleset_rule_variable_input_element_number" autoFocus type="number" onChange={(e) => { }} onBlur={(e) => { handlePagChange(e.target.value, source_i) }} onKeyUp={(e) => { if (e.key === "Enter") { handlePagChange(e.target.value, source_i) } }} defaultValue={rule.sources[source_i]?.page || 1} style={{ border: "none", width: ((rule.sources[source_i]?.page || 1).toString().length * 7.4 + 20).toString() + "px" }} />
                                                </div>
                                            }
                                        </div>
                                    }
                                    {isSourceDocOpen === source_i &&
                                        <div className="app__ruleset_rule_source_input_container" onMouseLeave={() => { setIsSourceDocOpen(-1) }}>
                                            <div style={{ padding: "1px 10px 4px", width: "fit-content" }}>
                                                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>Sélection du document</div>
                                                <div className="app__ruleset_rule_source_input_container_scroll">
                                                    {Object.keys(capacity.rules?.gpu_data?.files).map((docCategory, index1) => {
                                                        if (docCategory === "Règlements") {
                                                            return (
                                                                <>
                                                                    {Object.keys(capacity.rules.gpu_data.files[docCategory]).map((docSubcategory, index3) => {
                                                                        return (
                                                                            <>
                                                                                <div key={index1 + index3} style={{ marginTop: "8px" }}></div>
                                                                                <div key={index1 + index3 + "_title"} className="ruleeditor__input_title" style={{ color: "#062134" }}>{docCategory} - {docSubcategory}</div>
                                                                                <div>
                                                                                    {capacity.rules.gpu_data.files[docCategory][docSubcategory].map((docItem, index2) => {
                                                                                        var isSelected = false;
                                                                                        if (docItem?.url && docItem.url === rule.sources[source_i].doc?.url) {
                                                                                            isSelected = true;
                                                                                        }
                                                                                        return (
                                                                                            <div key={index2} className={`app__ruleset_rule_source_doc_item ${isSelected ? "app__ruleset_rule_source_doc_item_selected" : ""}`} onClick={() => { handleDocClick(docItem, source_i) }}>{docItem?.title}</div>
                                                                                        )
                                                                                    })}
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })
                                                                    }
                                                                </>
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                <>
                                                                    <div key={index1} style={{ marginTop: "8px" }}></div>
                                                                    <div key={index1 + "_title"} className="ruleeditor__input_title" style={{ color: "#062134" }}>{docCategory}</div>
                                                                    <div>
                                                                        {capacity.rules.gpu_data.files[docCategory].map((docItem, index2) => {
                                                                            var isSelected = false;
                                                                            if (docItem?.url && docItem?.url === rule?.source?.doc?.url) {
                                                                                isSelected = true;
                                                                            }
                                                                            return (
                                                                                <div key={index2} className={`app__ruleset_rule_source_doc_item ${isSelected ? "app__ruleset_rule_source_doc_item_selected" : ""}`} onClick={() => { handleDocClick(docItem, source_i) }}>{docItem?.title}</div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            )
                        }
                    })}
                </div>
            }
            {(capacity?.isModel === false && rule?.sources && rule.sources.length === 3 && rule.sources[0]?.doc?.url) &&
                <div className="app__ruleset_rule_source_container">
                    <div className="app__ruleset_rule_description_italic">{rule.sources[1].doc?.url ? "Sources :" : "Source :"}</div>
                    {rule.sources.map((source, source_i) => {
                        if (source?.doc?.url) {
                            return (
                                <a className="app__ruleset_rule_source_link" href={`${source.doc.url}${(source?.page && source.page !== "1") ? "#page=" + source.page : ""}`} target="_blank">
                                    {source.doc.title}{(source?.page && source.page !== "1") ? " (page " + source.page + ")" : ""}
                                </a>
                            )
                        }
                    })}
                </div>
            }

            {/* COMMENT */}
            {capacity?.isModel &&
                <div className="app__ruleset_rule_source_container">
                    <div className="app__ruleset_rule_description_italic">Commentaire :</div>
                    <textarea id={`${rule_id}_comment_input_string_long`} placeholder='Entrez un commentaire ici' className={`app__ruleset_rule_variable_input_element_textarea`} rows={nbRowsComment} onChange={(e) => { handleCommentChange(e.target.value) }} onBlur={(e) => { updateComment(e.target.value) }}></textarea>
                </div>
            }
            {(capacity?.isModel === false && rule?.comment) &&
                <div className="app__ruleset_rule_source_container">
                    <div className="app__ruleset_rule_description_italic">Commentaire :</div>
                    <div style={{whiteSpace: 'pre-line', lineHeight: '12px'}}>{rule.comment}</div>
                </div>
            }

            {/* PARAMS (CONDITION AND PERIMETER) */}
            {(data?.params?.condition?.value === true || data?.params?.perimeter?.value === true) &&
                <div className={`app__ruleset_rule_condition_perimeter_maincontainer ${isParamsVisible ? "" : "app__ruleset_rule_condition_perimeter_maincontainer_closed"}`}>
                    <div className={`app__ruleset_rule_condition_perimeter_maincontainer_arrow_down ${isParamsVisible ? "app__ruleset_rule_condition_perimeter_maincontainer_arrow_hidden" : ""}`} onClick={() => { paramsOpen() }}><img src={ico_arrow} alt="arrow_up" /></div>
                    {/* CONDITION */}
                    {data?.params?.condition?.value === true &&
                        <>
                            {/* <div className="app__ruleset_rule_separator"></div> */}
                            {/* <div className="app__ruleset_rule_condition_title_container">Condition d'application de la règle :</div> */}
                            <div className="app__ruleset_rule_condition_container">
                                {data?.params?.condition?.data !== null ?
                                    <>
                                        <div className={`app__ruleset_rule_condition_box_full ${data?.params?.condition?.data?.interpreted === false ? "app__ruleset_rule_condition_box_full_invalid" : ""}`}>
                                            <div className="app__ruleset_rule_condition_box_full_header">
                                                <div>Cette règle s'applique uniquement si :</div>
                                                <img src={ico_close} alt="close" onClick={() => { condition_Delete(rule_id) }} />
                                            </div>
                                            <div>
                                                {(data?.params?.condition?.data?.data?.description_splitted && data.params.condition.data.data.description_splitted.length > 0) ?
                                                    <div className="app__ruleset_rule_description">
                                                        {data.params.condition.data.data.description_splitted.map((description_part, index) => {
                                                            var variables_match_index = -1;
                                                            for (var i = 0; i < data.params.condition.data.data.variables_description.length; i++) {
                                                                if (data.params.condition.data.data.variables_description[i].label === description_part) {
                                                                    variables_match_index = i;
                                                                    break;
                                                                }
                                                            }
                                                            if (variables_match_index === -1) {
                                                                return (
                                                                    description_part
                                                                )
                                                            }
                                                            else {
                                                                // if (data.params.condition.data.data.variables_description[variables_match_index].type === "Node_UserInput_Number" || data.params.condition.data.data.variables_description[variables_match_index].type === "Node_UserInput_Number_Range" || data.params.condition.data.data.variables_description[variables_match_index].type === "Node_UserInput_Boolean" || data.params.condition.data.data.variables_description[variables_match_index].type === "Node_UserInput_Bounds" || data.params.condition.data.data.variables_description[variables_match_index].type === "Node_UserInput_Lands" || data.params.condition.data.data.variables_description[variables_match_index].type === "Node_UserInput_PLUZone" || data.params.condition.data.data.variables_description[variables_match_index].type === "Node_UserInput_Levels" || data.params.condition.data.data.variables_description[variables_match_index].type === "Node_UserInput_Buildings") {
                                                                if (data.params.condition.data.data.variables_description[variables_match_index].type.includes("Node_UserInput_")) {
                                                                    return (
                                                                        <RuleVariable key={index} ruleId={rule_id} ruleLabel={rule.name} ruleType={"condition"} variable={data.params.condition.data.data.variables_description[variables_match_index]} varType={"condition"} updateVariable={updateVariable} capacity={capacity} mapDrawMode={mapDrawMode} setMapDrawMode={setMapDrawMode} hiddenRule={hiddenRule} setHiddenRule={setHiddenRule} />
                                                                    )
                                                                }
                                                                return (
                                                                    <span key={index} className="app__ruleset_rule_description_input">{description_part}</span>
                                                                )
                                                            }
                                                        })}
                                                    </div>
                                                    :
                                                    <div className="app__ruleset_rule_description">{data.description}</div>
                                                }
                                                {/* {nodeHelpers.nodeInterpretor([data.params.condition.data.data.composition.nodes[0].data.source[0]], capacity) === true ?
                                            <div className="app__ruleset_rule_description">Test=OK</div>
                                            :
                                            <div className="app__ruleset_rule_description">Test=NO</div>
                                        } */}
                                                {/* {data?.params?.condition?.data?.interpreted === true &&
                                            <div className="app__ruleset_rule_condition_result_green">applicable</div>
                                        } */}
                                                {data?.params?.condition?.data?.interpreted === false &&
                                                    <div className="app__ruleset_rule_condition_warning_red"><img src={ico_warning_red} alt="" />la condition n'est pas remplie</div>
                                                }
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="app__ruleset_rule_condition_box_full_inactive">
                                            {/* <div className="app__ruleset_rule_condition_box_full_header" style={{ fontWeight: "500" }}>Cette règle s'applique dans tous les cas.</div> */}
                                            <div className="app__ruleset_rule_description" style={{ textAlign: 'center' }}><span className="app__ruleset_rule_condition_link" onClick={() => { ruleCatalog_Open(rule_id, "condition") }}>Ajouter une condition d'application</span></div>
                                        </div>
                                    </>
                                }
                            </div>
                        </>
                    }
                    {/* PERIMETER */}
                    {data?.params?.perimeter?.value === true &&
                        <>
                            {/* <div className="app__ruleset_rule_separator"></div> */}
                            {/* <div className="app__ruleset_rule_condition_title_container">Périmètre d'application de la règle :</div> */}
                            <div className="app__ruleset_rule_condition_container">
                                {data?.params?.perimeter?.data !== null ?
                                    <>
                                        <div className={`app__ruleset_rule_condition_box_full ${data?.params?.perimeter?.data?.interpreted && data?.params?.perimeter?.data?.interpreted.length === 0 ? "app__ruleset_rule_condition_box_full_invalid" : ""}`}>
                                            <div className="app__ruleset_rule_condition_box_full_header">
                                                <div>Cette règle s'applique uniquement sur :</div>
                                                <img src={ico_close} alt="close" onClick={() => { perimeter_Delete(rule_id) }} />
                                            </div>
                                            {(data?.params?.perimeter?.data?.data?.description_splitted && data.params.perimeter.data.data.description_splitted.length > 0) ?
                                                <div className="app__ruleset_rule_description">
                                                    {data.params.perimeter.data.data.description_splitted.map((description_part, index) => {
                                                        var variables_match_index = -1;
                                                        for (var i = 0; i < data.params.perimeter.data.data.variables_description.length; i++) {
                                                            if (data.params.perimeter.data.data.variables_description[i].label === description_part) {
                                                                variables_match_index = i;
                                                                break;
                                                            }
                                                        }
                                                        if (variables_match_index === -1) {
                                                            return (
                                                                description_part
                                                            )
                                                        }
                                                        else {
                                                            // if (data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_Number" || data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_Number_Range" || data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_Boolean" || data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_Bounds" || data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_Lands" || data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_PLUZone" || data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_Levels" || data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_Buildings" || data.params.perimeter.data.data.variables_description[variables_match_index].type === "Node_UserInput_Draw_Point") {
                                                            if (data.params.perimeter.data.data.variables_description[variables_match_index].type.includes("Node_UserInput_")) {
                                                                return (
                                                                    <RuleVariable key={index} ruleId={rule_id} ruleLabel={rule.name} ruleType={"perimeter"} variable={data.params.perimeter.data.data.variables_description[variables_match_index]} varType={"perimeter"} updateVariable={updateVariable} capacity={capacity} mapDrawMode={mapDrawMode} setMapDrawMode={setMapDrawMode} hiddenRule={hiddenRule} setHiddenRule={setHiddenRule} />
                                                                )
                                                            }
                                                            else if (data.params.perimeter.data.data.variables_description[variables_match_index].type === "result") {
                                                                return (
                                                                    <RuleResult rule={data?.params?.perimeter?.data} />
                                                                )
                                                            }
                                                            return (
                                                                <span key={index} className="app__ruleset_rule_description_input">{description_part}</span>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                                :
                                                <div className="app__ruleset_rule_description">{data.description}</div>
                                            }
                                            {(data?.params?.perimeter?.data?.interpreted && (data?.params?.perimeter?.data?.interpreted.length === 0 || data?.params?.perimeter?.data?.interpreted[0]?.userData?.result === "0,00")) &&
                                                <div className="app__ruleset_rule_condition_warning_red"><img src={ico_warning_red} alt="" />le périmètre est invalide</div>
                                            }
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="app__ruleset_rule_condition_box_full_inactive">
                                            {/* <div className="app__ruleset_rule_condition_box_full_header" style={{ fontWeight: "500" }}>Cette règle s'applique sur l'ensemble de la surface du terrain.</div> */}
                                            <div className="app__ruleset_rule_description" style={{ textAlign: 'center' }}><span className="app__ruleset_rule_condition_link" onClick={() => { ruleCatalog_Open(rule_id, "perimeter") }}>Ajouter un périmètre d'application</span></div>
                                        </div>
                                    </>
                                }
                            </div>
                        </>
                    }
                    <div className="app__ruleset_rule_condition_perimeter_maincontainer_arrow_up" onClick={() => { paramsClose() }}><img src={ico_arrow} alt="arrow_up" /></div>
                </div>
            }

            {/* ACTIONS */}
            {isActions &&
                <div className="app__ruleset_document_actions_container scale-up-topright" onMouseLeave={() => { setIsActions(false) }}>
                    <div className="app__landsvalidation_popup_button_second" onClick={handleClickDelete}>Supprimer cette règle</div>
                </div>
            }
            {isDelete &&
                <div className="app__ruleset_rule_actions_container" onMouseLeave={() => { setIsDelete(false) }}>
                    <div className="app__bound_type_modify_title_big">Supprimer cette règle ?</div>
                    <div className="app__ruleset_document_deletion_container">
                        <div className="app__landsvalidation_popup_button" onClick={() => { setIsDelete(false) }}>Conserver</div>
                        <div className="app__landsvalidation_popup_button_second" onClick={() => { rule_Delete(rule_id) }}>Supprimer</div>
                    </div>
                </div>
            }
        </div>
    );
};

export default Rule;